import Vue from 'vue'
import VueI18n from 'vue-i18n'


Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'de',
  messages: {
    de: {
      'Anrede': 'Anrede',
      'Kontakt': 'Kontakt',
      'Top-Händler - Von rewaco ausgezeichneter Kundenservice.': 'Top-Händler - Von rewaco für seinen Kundenservice ausgezeichneter Händler.',
      'Agreement': 'Ich bestätige, dass ich die Datenschutzerklärung gelesen habe und stimme der Verarbeitung meiner Daten zu.',
      'Dein Name': 'Dein Name',
      'Deine E-Mail': 'Deine E-Mail',
      'Deine Telefonnummer': 'Deine Telefonnummer',
      'Deine Nachricht': 'Your message',
      'Persönlicher Text': 'Persönlicher Text',
      'Kopie an mich senden': 'Kopie an mich senden',
      'Nachricht senden': 'Nachricht senden',
      'Datenschutzerklärung': 'Datenschutzerklärung',
      'Betreff': 'Betreff',
      'Deine Angaben': 'Deine Angaben',
      'Gesendet': 'Senden',
      'Strasse': 'Straße und Hausnummer',
      'Ort': 'Stadt',
      'PLZ': 'PLZ',
      'Leider ist ein Fehler aufgetreten': 'Leider ist ein Fehler aufgetreten',
      'Deine Nachricht wurde bereits erfolgreich gesendet': 'Deine Nachricht wurde bereits erfolgreich gesendet',
      'Deine Anfrage wurde erfolgreich eingetragen': 'Deine Anfrage wurde erfolgreich eingetragen',
      'Um deine Anfrage zu bestätigen erhälst du eine E-Mail': 'Um deine Anfrage zu bestätigen erhälst du eine E-Mail',

    },
    en: {
      'Anrede': 'Title',
      'Suche nach PLZ, Ort': 'Search by postcode, city',
      'Kontakt': 'Contact',
      'Alle': 'All',
      'Deine Angaben': 'Your data',
      'Gesendet': 'Send',
      'Leider ist ein Fehler aufgetreten': 'Sorry, an error has occurred',
      'Bitte versuche es zu einem späteren Zeitpunkt erneut': 'Please try it later again',
      'Dein Name': 'Your name',
      'Deine E-Mail': 'Your email',
      'Deine Telefonnummer': 'Your telephone number',
      'Deine Nachricht': 'Your message',
      'Gewünschtes Abhol- Abgabedatum (Von-Bis)': 'Desired date (From-To)',
      'Von': 'From',
      'Bis': 'To',
      'Strasse': 'Road',
      'PLZ': 'Zip-Code',
      'Ort': 'City',
      'Datenschutzerklärung': 'Privacy policy',
      'Nachricht senden': 'Send message',
      'Top-Händler - Von rewaco ausgezeichneter Kundenservice.': 'Top-Dealer - Dealer awarded by rewaco for its customer service.',
      'Top-Händler': 'Top-Dealer',
      'Weitere Händler anzeigen': 'More',
      'Nachricht an': 'Message to',
      'Allgemein': 'General',
      'Verkauf': 'Sale',
      'Vermietung': 'Rent',
      'Service': 'Service',
      'Fahrzeugangebot des Händlers': 'Dealer\'s vehicle offer',
      'Betreff': 'Subject',
      'Persönlicher Text': 'Your personal text',
      'Ich möchte einen Dreisitzer mieten': 'I would like to rent a three-seater',
      'Ich möchte einen Zweisitzer mieten': 'I would like to rent a two-seater',
      'Keine Händler gefunden.': 'No dealers found.',
      'Deine Anfrage wurde erfolgreich eingetragen': 'Your request was successfully submitted',
      'Deine Nachricht wurde bereits erfolgreich gesendet': 'Your message has already been successfully sent',
      'Deine Nachricht wurde erfolgreich gesendet': 'Your message was successfully sent',
      'Um deine Anfrage zu bestätigen erhälst du eine E-Mail': 'To confirm your request you will receive an email',
      'Agreement': 'I confirm that I have read and consent to the Privacy Policy and I agree to the processing of my data.',

    },
    fr: {
      'Anrede': 'Titre',
      'Suche nach PLZ, Ort': 'Recherche par code postal, ville',
      'Kontakt': 'Contact',
      'Alle': 'All',
      'Gesendet': 'Envoyer',
      'Bitte versuche es zu einem späteren Zeitpunkt erneut': 'Please try it later again',
      'Dein Name': 'Votre nom',
      'Deine Angaben': 'Vos données',
      'Deine E-Mail': 'Votre email',
      'Deine Telefonnummer': 'Votre téléphone',
      'Deine Nachricht': 'Votre message',
      'Gewünschtes Abhol- Abgabedatum (Von-Bis)': 'Desired date (From-To)',
      'Von': 'From',
      'Bis': 'To',
      'Strasse': 'Rue',
      'PLZ': 'Code postal',
      'Ort': 'Localité',
      'Leider ist ein Fehler aufgetreten': 'Désolé, une erreur s\'est produite',
      'Können Sie mich bitte zurückrufen?': 'Can you please call me back?',
      'Bieten Sie Finanzierungsmöglichkeiten an?': 'Do you offer financing options?',
      'Können bei Ihnen Helme geliehen werden?': 'Can helmets be rented from you?',
      'Können auch 2 Beifahrer mitgenommen werden?': 'Can 2 co-drivers also be taken along?',
      'Ich stimme der Verarbeitung meiner Daten zu.': 'J\'accepte le traitement de mes données.',
      'Kopie an mich senden': 'Send a copy to me',
      'Datenschutzerklärung': 'Privacy policy',
      'Top-Händler - Von rewaco ausgezeichneter Kundenservice.': 'Top-Dealer - Dealer awarded by rewaco for its customer service.',
      'Top-Händler': 'Top-Dealer',
      'Weitere Händler anzeigen': 'Charger plus',
      'Nachricht an': 'Message to',
      'Allgemein': 'General',
      'Verkauf': 'Vente',
      'Vermietung': 'Loyer',
      'Service': 'Service',
      'Fahrzeugangebot des Händlers': 'Dealer\'s vehicle offer',
      'Nachricht senden': 'Envoyer message',
      'Betreff': 'Sujet',
      'Persönlicher Text': 'Ici, vous pouvez ajouter à votre message plus de texte',
      'Deine Nachricht wurde bereits erfolgreich gesendet': 'Votre message a déjà été envoyé avec succès',
      'Deine Anfrage wurde erfolgreich eingetragen': 'Votre demande a été soumise avec succès',
      'Um deine Anfrage zu bestätigen erhälst du eine E-Mail': 'Pour confirmer votre demande, vous recevrez un courrier électronique',
      'Agreement': 'Je confirme que j\'ai lu et que j\'accepte la politique de confidentialité et que j\'accepte le traitement de mes données.',
    },
  }
});
